Vue.asyncComponent('bp-tab', {
    props: {
        activeTabId: {
            required: true,
        },
        id: {
            required: true,
        },
    },
}, 'blueprints/utils/tabs/bp-tab.html');